const findByEntityAndActionMethod = (emails, entity, actionMethod) =>
  emails.find(
    email => email.entity === entity && email.actionMethod === actionMethod,
  )

export default findByEntityAndActionMethod
